import React, { useState } from 'react';
import {
  Box,
  IconButton,
  useTheme,
  useMediaQuery,
  Drawer,
} from '@mui/material';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import SidebarMenu from './SidebarMenu';
import style from './style.module.scss';

const AppSidebar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [isCollapsed, setIsCollapsed] = useState<boolean>(true);

  const toggleSidebar = (): void => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <>
      {/* Permanent sidebar for desktop */}
      {!isMobile && (
        <Box
          component="aside"
          className={`${style.sidebar} ${style.desktop}`}
          sx={{
            width: isCollapsed ? '60px' : '200px',
            transition: 'width 0.3s',
            overflowX: 'hidden',
            height: '100vh',
            backgroundColor: '#f5f5f5',
            borderRight: '1px solid #ddd',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <IconButton
            onClick={toggleSidebar}
            className={style.trigger}
            aria-label={isCollapsed ? 'Open sidebar' : 'Collapse sidebar'}
            sx={{ alignSelf: 'flex-end', m: 1 }}
          >
            {isCollapsed ? <MenuIcon /> : <MenuOpenIcon />}
          </IconButton>
          <SidebarMenu />
        </Box>
      )}

      {/* Temporary drawer for mobile */}
      {isMobile && (
        <Drawer
          variant="temporary"
          open={!isCollapsed}
          onClose={toggleSidebar}
          PaperProps={{ className: `${style.sidebar} ${style.mobile}` }}
        >
          <IconButton
            onClick={toggleSidebar}
            className={style.trigger}
            aria-label="Close sidebar"
            sx={{ alignSelf: 'flex-end', m: 1 }}
          >
            <MenuOpenIcon />
          </IconButton>
          <SidebarMenu />
        </Drawer>
      )}
    </>
  );
};

export default AppSidebar;
